// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1337) return "static/chunks/1337-7752c2b431937b46.js";
	if (chunkId === 1071) return "static/chunks/1071-abdd69c1a4991cdf.js";
	if (chunkId === 3183) return "static/chunks/3183-d1402a30d44177b6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2336":"0182a22d3d577394","2536":"de3b7bd3e6fc2a7e","3340":"c6e3128ea185d14f","3833":"04faf3755af85cd5","3924":"98f73ec6313990d4","5841":"a374040fc430cd3c","5857":"9dd246a9f70dc1af","6539":"992a5eae175858e7","7400":"1f6a557c1489681f","8407":"232e3770808932ac","9044":"1cb175a54734dbd5","9354":"1b47e401b8a8747c"}[chunkId] + ".js";
};